export { default } from "./AspectRatioContainer.styled";
